/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const FreeshipCouponCreatePage = lazyLoad(
  () => import('./index'),
  module => module.FreeshipCouponCreatePage
);
